import { Dispatch, SetStateAction } from "react";
import { GetVariable } from "./EmailBuilderUtils";
import NewButton from "../../../elements/NewButton";
import DropdownOptionWithIcon from "../../Menus/DropdownOptionWithIcon";
import { EmailVariables } from "./EmailBuilderTypes";
import { EmailVariableTypes } from "./EmailBuilderTypes";
import IconButton from "../../../elements/IconButton";

interface HeaderProps {
  title: string;
  variables: EmailVariables[];
  setVariables: Dispatch<SetStateAction<EmailVariables[]>>;
  expandAll: boolean;
  setExpandAll: Dispatch<SetStateAction<boolean>>;
}

function BuilderHeader({
  title,
  variables,
  setVariables,
  expandAll,
  setExpandAll,
}: HeaderProps) {
  return (
    <div className="d-flex justify-content-between border-bottom pb-2 align-items-center">
      <h3>{title}</h3>
      <div>
        <IconButton
          icon={expandAll ? "arrow-collapse" : "arrow-expand"}
          onClick={() => setExpandAll((prev) => !prev)}
        />
        <NewButton
          title="Add Variable"
          options={<VariableOptions addVariable={addVariable} />}
          onlyOptions
          placement="autoVerticalEnd"
        />
      </div>
    </div>
  );

  function addVariable(variableType: EmailVariableTypes) {
    const newVariable = GetVariable(variableType);

    // When adding RecordDynamic variable, check if other RecordDynamic variables have been added
    // If so and there is only one module being used so far,
    // automatically set the same module for the new variable.
    if (newVariable?.Type === "RecordDynamic") {
      const uniqueModules = variables.reduce((mods: string[], currentVar) => {
        if (currentVar.Type !== "RecordDynamic") return mods;

        const modName = currentVar.ModuleAPIName;

        if (modName && !mods.includes(modName)) {
          mods.push(modName);
        }

        return mods;
      }, []);

      if (uniqueModules.length === 1) {
        newVariable.ModuleAPIName = uniqueModules[0];
      }
    }

    if (!newVariable) return;

    setVariables((prev) => {
      return [...prev, newVariable];
    });
  }
}

function VariableOptions({
  addVariable,
}: {
  addVariable: (variableType: EmailVariableTypes) => void;
}) {
  return (
    <>
      <DropdownOptionWithIcon
        name="Record Dynamic"
        onClick={() => {
          addVariable("RecordDynamic");
        }}
        icon="mdi mdi-file-search-outline"
        disabled={false}
      />
      <DropdownOptionWithIcon
        name="Record Value"
        onClick={() => {
          addVariable("RecordValue");
        }}
        icon={"mdi mdi-file-outline"}
        disabled={true} // TODO: Add support when record is provided to component.
      />
      <DropdownOptionWithIcon
        name="Template Value"
        onClick={() => {
          addVariable("TemplateValue");
        }}
        icon={"mdi mdi-application-variable-outline"}
        disabled={false}
      />
      <DropdownOptionWithIcon
        name="Value"
        onClick={() => {
          addVariable("Value");
        }}
        icon={"mdi mdi-format-text"}
        disabled={false}
      />
      <DropdownOptionWithIcon
        name="Search By Email"
        onClick={() => {
          addVariable("SearchByEmail");
        }}
        icon={"mdi mdi-account-search"}
        disabled={false}
      />
    </>
  );
}

export default BuilderHeader;
